import React from 'react';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { useParams } from 'react-router-dom';
import { PageHeader } from 'antd';

import TeamSmartPosBody from '../../../components/client/TeamSmartPosBody';
import { useTeamDetails } from '../../../components/client/useTeamDetails';
import { useTeamMembers } from '../../../components/client/useTeamMembers';
import CenteredSpinner from '../../../components/CenteredSpinner';
import TeamAdminOnly from '../../../components/client/TeamAdminOnly';

/**
 * Smart POS — a team activity: a member starts a payment here and chooses how
 * the customer completes it (link, on-screen QR, and later a driven terminal or
 * armed QR stand). Initiation lives on this authenticated surface under team
 * access rules; the payer surface only executes the resulting context.
 */
const TeamSmartPosScreen = ({
  locStrings,
  isAdmin,
}) => {
  const { teamId, clientId } = useParams();
  const team = useTeamDetails(teamId);
  const teamMembers = useTeamMembers(teamId, team, clientId);
  const loading = !(team && teamId && clientId && Array.isArray(teamMembers));

  return <>
      <PageHeader
        ghost={false}
        title="Back"
        onBack={(() => window.history.back())}
      />
      <TeamAdminOnly teamId={teamId} require="member">
      {loading &&
        <CenteredSpinner loading={true} noLayout />
      }
      {!loading && !team.smartPosEnabled &&
        <div style={{ textAlign: 'center', padding: '48px 16px' }}>
          <TeamAdminOnly teamId={teamId} require="member">
            <p style={{ fontSize: '16px' }}>Smart POS isn&apos;t turned on for this team yet.</p>
            <p style={{ color: '#888' }}>A team manager can enable it from the team page.</p>
          </TeamAdminOnly>
        </div>
      }
      {!loading && !!team.smartPosEnabled &&
        <TeamSmartPosBody
          locStrings={locStrings}
          teamId={teamId}
          team={team}
          clientId={clientId}
          teamMembers={teamMembers}
          isAdmin={isAdmin}
        />
      }
      </TeamAdminOnly>
    </>;
};

export default TeamSmartPosScreen;
